import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TimersService {

  constructor() { }



  transform(value: number): string {
    const horas   = Math.floor(value / 3600);
    const minutos = Math.floor((value - (horas * 3600)) / 60);
    const segundos = value - (horas * 3600) - (minutos * 60);

    if (horas   < 10) {
      if (minutos < 10){
        if (segundos < 10){
          return '0'+horas+':0'+minutos +':0'+segundos;
        } else{
          return '0'+horas+':0'+minutos +':'+segundos;
        }
      } else{
        if (segundos < 10){
          return '0'+horas+':'+minutos +':0'+segundos;
        } else{
          return '0'+horas+':'+minutos +':'+segundos;
        }
      }
    } else{
      if (minutos < 10){
        if (segundos < 10){
          return horas+':0'+minutos +':0'+segundos;
        } else{
          return horas+':0'+minutos +':'+segundos;
        }
      } else{
        if (segundos < 10){
          return horas+':'+minutos +':0'+segundos;
        } else{
          return horas+':'+minutos +':'+segundos;
        }
      }
    }
  }
}

